<template>
    <el-dialog title="小程序详情" :visible="true" width="500px" :close-on-click-modal="false" :before-close="cancel">
        <el-form :model="item" label-width="100px" :label-position="labelPosition">
            <el-form-item label="头像" prop="logo" style="margin-bottom: 0;">
                <avatar :changable="item.origin === 0" :size="40" :url="item.logo" @image-ok="changeLogo" ref="avatar"></avatar>
            </el-form-item>
            <el-form-item label="小程序名称" prop="name" style="margin-bottom: 10px;">
                <div class="content">
                    <span v-if="!editType" class="info">{{item.name}}</span>
                    <div class="edit-content" v-else>
                        <input type="text" placeholder="输入小程序名，推荐4-12个字" class="input" ref="input" @blur="changeName" :maxlength="24" v-model="nameBackup">
                        <span class="action">
                            <i class="act-icon clear" @mousedown="clear"></i>
                        </span>
                    </div>
                    <span class="btn" @click="editName" v-show="!editType && item.origin === 0">编辑</span>
                    <p class="error-info" v-if="editType">{{errorInfo}}</p>
                </div>
            </el-form-item>
            <el-form-item label="小程序ID" prop="appId" style="margin-bottom: 10px;">
                <span>{{item.appId}}</span>
            </el-form-item>
            <el-form-item label="小程序简介" prop="introduction" style="margin-bottom: 10px;">
                <div class="content">
                    <p v-if="!item.introduction && !showAddInput && item.origin === 0">&ndash;&nbsp;<a class="add" @click="addIntro">添加</a></p>
                    <p v-if="item.introduction && !modify" class="info textarea-info">
                        {{item.introduction}}
                    <span class="btn" @click="editIntro" v-show="introBackup && !modify && item.origin === 0">编辑</span>
                    </p>
                    <div class="edit-textarea" v-show="showAddInput">
                        <textarea class="input textarea" type="text" ref="intro" @blur="modifyIntro" v-model="introBackup" :maxlength="120" placeholder="请确认简介内容不包含国家法律法规禁止内容"></textarea>
                        <span class="num" :class="{'danger': introBackup.length === 120}">{{!introBackup.length ? 0 : introBackup.length}}/120</span>
                    </div>
                </div>
            </el-form-item>
            <el-form-item label="所属主体" prop="companyName" style="margin-bottom: 10px;">
                <span class="company-name">{{item.companyName}}</span>
            </el-form-item>
            <el-form-item label="主体UID" prop="mid" style="margin-bottom: 10px;">
                <span>{{item.mid}}</span>
            </el-form-item>
            <el-form-item label="主体昵称" prop="nickName" style="margin-bottom: 10px;">
                <span>{{item.nickName}}</span>
            </el-form-item>
        </el-form>
    </el-dialog>
</template>
<script>
    import Avatar from '@/components/Avatar.vue';
    import dao from '@/lib/dao.js';
    export default {
        components: {
            Avatar,
        },
        props: {
            item: {
                type: Object,
                default() {
                    return {}
                }
            },
            visible: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                editType: false,
                modify: false,
                nameBackup: '',
                introBackup: '',
                nameReg: new RegExp('^[\\u4e00-\\u9fa5_a-zA-Z0-9]{4,24}$'),
                errorInfo: '',
                showAddInput: false,
                labelPosition: 'right'
            }
        },
        methods: {
            cancel() {
                this.$emit('update:visible', false);
            },
            changeLogo(url) {
                dao.up.changeLogo({
                    appId: this.item.vAppId,
                    logo: url
                }).then(_ => {
                    this.item.logo = url;
                }).catch(msg => {
                    this.$message.error(msg);
                });
            },
            clear(event) {
                this.nameBackup = '';
                this.$refs.input.focus();
                event.preventDefault();
            },
            clearTextarea() {
                this.introBackup = '';
                this.$refs.intro.focus();
                event.preventDefault();
            },
            editName() {
                this.editType = true;
                this.$nextTick(_ => {
                    this.$refs.input.focus();
                });
            },
            changeName() {
                if (this.nameBackup === this.item.name) {
                    this.editType = false;
                    return;
                }
                if (!this.nameBackup) {
                    this.errorInfo = '输入内容不能为空';
                } else if (!this.nameReg.test(this.nameBackup)) {
                    this.errorInfo = '只能输入中文、英文和数字, 限4-24个字';
                } else {
                    dao.up.checkName({
                        appId: this.item.vAppId,
                        name: this.nameBackup
                    }).then(_ => {
                        dao.up.changeName({
                            appId: this.item.vAppId,
                            name: this.nameBackup
                        }).then(_ => {
                            this.item.name = this.nameBackup;
                            this.editType = false;
                        }).catch(msg => {
                            this.editType = false;
                            this.nameBackup = this.item.name;
                            this.$message.error(msg);
                        });
                    }).catch(msg => {
                        this.errorInfo = msg;
                    });
                }
            },
            editIntro() {
                this.modify = true;
                this.showAddInput = true;
                this.$nextTick(_ => {
                    this.$refs.intro.focus();
                });
            },
            modifyIntro() {
                if (this.introBackup === this.item.introduction) {
                    this.showAddInput = false;
                    this.modify = false;
                    return;
                }
                dao.up.modifyIntro({
                    appId: this.item.vAppId,
                    introduction: this.introBackup
                }).then(_ => {
                    this.item.introduction = this.introBackup;
                    this.showAddInput = false;
                    this.modify = false;
                }).catch(msg => {
                    this.showAddInput = false;
                    this.modify = false;
                    this.introBackup = this.item.introduction;
                    this.$message.error(msg);
                });
            },
            addIntro() {
                this.showAddInput = true;
                this.$nextTick(_ => {
                    this.$refs.intro.focus();
                });
            }
        },
        mounted() {
            this.nameBackup = this.item.name;
            this.introBackup = this.item.introduction || '';
        }
    }
</script>
<style lang="less" scoped>
.btn {
    cursor: pointer;
    color: #789AFF;
    font-size: 12px;
}
.intro {
    max-width: 366px;
    padding-top: 10px;
    line-height: 18px;
}
.content {
    display: inline-block;
    position: relative;
    .add {
        cursor: pointer;
        color: #789AFF;
        font-size: 12px;
        margin-left: 10px;
    }

    .info {
        cursor: pointer;
        display: inline-block;
        width: 153px;
        line-height: 18px;
        margin-top: 12px;
        word-break: break-all;

        &.textarea-info {
            width: 366px;
        }
    }
    .edit-content {
        position: relative;
        height: 28px;
        display: inline-block;
        line-height: 28px;   
    }
    .input {
        border: 1px solid #E0E5EC;
        height: 28px;
        border-radius: 2px;
        box-sizing: border-box;
        padding: 0 30px 0 10px;
        color: #5C667E;
        font-size: 14px;
        width: 230px;
        outline: none;

        &.textarea {
            padding: 5px;
            width: 366px;
            height: 70px;
            margin-top: 13px;
            border-radius: 2px;
        }
    }
    .input:focus~.act-icon {
        visibility: visible;
    }
    .act-icon {
        cursor: pointer;
        position: absolute;
        top: 5px;
        right: 5px;
        height: 17px;
        text-align: center;
        // display: none;
        visibility: hidden;
    }
    .edit-textarea {
        position: relative;
        height: 70px;

        .input.textarea {
            padding-right: 10px;
        }
        .num {
            position: absolute;
            right: 5px; 
            bottom: -27px;
            color: #9AA7C1;
            font-size: 12px;
            line-height: 12px;

            &.danger {
                color: #FF7B58;
            }
        }
    }
    .input.textarea::-webkit-scrollbar-track {
        background-color: #F5F5F5;
    }
    .input.textarea::-webkit-scrollbar {
        width: 4px;
        height: 10px;
        background-color: #F5F5F5;
    }
    .input.textarea::-webkit-scrollbar-thumb {
        border-radius: 5px;
        background-color: rgba(153, 153, 153, 0.5);
        height: 10px;
    }
    .clear {
        width: 17px;
        height: 17px;
        display: inline-block;
        background: url(./../assets/close.png) center / 17px no-repeat;
    }
    .error-info {
        color: #FF7B58;
        font-size: 12px;
        line-height: 14px;
        position: absolute;
        bottom: -10px;
        left: 11px;
    }
    .input::-moz-placeholder {
        color: #9AA7C1;
        font-size: 12px;
    }
    .input::-webkit-input-placeholder {
        color: #9AA7C1;
        font-size: 12px;
    }
    .input::-ms-input-placeholder {
        color: #9AA7C1;
        font-size: 12px;
    }
}
.company-name {
    line-height: 18px;
    word-break: break-all;
    display: inline-block;
    vertical-align: middle;
}
</style>


// WEBPACK FOOTER //
// src/components/UpEditDialog.vue